import type { Config } from 'dompurify'

type Mode = 'html' | 'text'

export const useSanitize = (
  dirty: string,
  mode: Mode = 'html',
  config?: Config
) => {
  const { $sanitizeHtml, $sanitizeText } = useNuxtApp()

  if (mode === 'text') {
    return $sanitizeText(dirty)
  }

  return $sanitizeHtml(dirty, config)
}